export const ExcelIcon = ({ width, height, color = 'black' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1742_56647)">
        <path
          d="M12.4219 16.25H10.2344V11.875"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.60938 8.75V3.125C4.60938 2.95924 4.67522 2.80027 4.79243 2.68306C4.90964 2.56585 5.06861 2.5 5.23438 2.5H12.7344L17.1094 6.875V8.75"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7344 2.5V6.875H17.1094"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.60938 11.875L7.73438 16.25"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.73438 11.875L4.60938 16.25"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.789 11.9998C16.789 11.9998 14.4898 11.392 14.3046 12.8592C14.1195 14.3264 17.307 13.6498 17.1 15.2592C16.907 16.756 14.6171 16.1185 14.6171 16.1185"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1742_56647">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.859375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CSVIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1742_56657)">
        <path
          d="M7.10938 15.693C6.94992 15.866 6.75681 16.0047 6.54186 16.1005C6.32692 16.1963 6.09468 16.2472 5.85938 16.25C4.82344 16.25 3.98438 15.2703 3.98438 14.0625C3.98438 12.8547 4.82344 11.875 5.85938 11.875C6.09468 11.8778 6.32692 11.9287 6.54186 12.0245C6.75681 12.1203 6.94992 12.259 7.10938 12.432"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.789 11.9998C11.789 11.9998 9.4898 11.392 9.30464 12.8592C9.11949 14.3264 12.307 13.6498 12.1 15.2592C11.907 16.756 9.61714 16.1185 9.61714 16.1185"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.60938 8.75V3.125C4.60938 2.95924 4.67522 2.80027 4.79243 2.68306C4.90964 2.56585 5.06861 2.5 5.23438 2.5H12.7344L17.1094 6.875V8.75"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7344 2.5V6.875H17.1094"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.9844 11.875L15.5469 16.25L17.1094 11.875"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1742_56657">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.859375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PDFIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1742_56666)">
        <path
          d="M17.7344 11.875H15.2344V16.25"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.1094 14.375H15.2344"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.60938 15H5.85938C6.27378 15 6.6712 14.8354 6.96423 14.5424C7.25725 14.2493 7.42188 13.8519 7.42188 13.4375C7.42188 13.0231 7.25725 12.6257 6.96423 12.3326C6.6712 12.0396 6.27378 11.875 5.85938 11.875H4.60938V16.25"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.60938 11.875V16.25H10.8594C11.4395 16.25 11.9959 16.0195 12.4062 15.6093C12.8164 15.1991 13.0469 14.6427 13.0469 14.0625C13.0469 13.4823 12.8164 12.9259 12.4062 12.5157C11.9959 12.1055 11.4395 11.875 10.8594 11.875H9.60938Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.60938 8.75V3.125C4.60938 2.95924 4.67522 2.80027 4.79243 2.68306C4.90964 2.56585 5.06861 2.5 5.23438 2.5H12.7344L17.1094 6.875V8.75"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.7344 2.5V6.875H17.1094"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1742_56666">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.859375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
